import { render, staticRenderFns } from "./SoliBtn.vue?vue&type=template&id=7959b728&scoped=true"
import script from "./SoliBtn.vue?vue&type=script&lang=js"
export * from "./SoliBtn.vue?vue&type=script&lang=js"
import style0 from "./SoliBtn.vue?vue&type=style&index=0&id=7959b728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7959b728",
  null
  
)

export default component.exports